// Utilidad para validar RUT chileno
export const validateRUT = (rut: string): boolean => {
  if (!rut) return false

  // Limpiar el RUT (remover puntos, guiones y espacios)
  const cleanRut = rut.replace(/[.-\s]/g, "").toUpperCase()

  if (cleanRut.length < 8 || cleanRut.length > 9) return false

  // Separar número y dígito verificador
  const rutNumber = cleanRut.slice(0, -1)
  const checkDigit = cleanRut.slice(-1)

  // Validar que el número sea numérico
  if (!/^\d+$/.test(rutNumber)) return false

  // Calcular dígito verificador
  let sum = 0
  let multiplier = 2

  for (let i = rutNumber.length - 1; i >= 0; i--) {
    sum += parseInt(rutNumber[i]) * multiplier
    multiplier = multiplier === 7 ? 2 : multiplier + 1
  }

  const remainder = sum % 11
  const calculatedDigit =
    remainder === 0 ? "0" : remainder === 1 ? "K" : (11 - remainder).toString()

  return checkDigit === calculatedDigit
}

export const formatRUT = (rut: string): string => {
  // Limpiar el RUT
  const cleanRut = rut.replace(/[.-\s]/g, "").toUpperCase()

  if (cleanRut.length < 2) return cleanRut

  // Formatear RUT con puntos y guión
  const rutNumber = cleanRut.slice(0, -1)
  const checkDigit = cleanRut.slice(-1)

  // Agregar puntos cada 3 dígitos desde la derecha
  const formattedNumber = rutNumber.replace(/\B(?=(\d{3})+(?!\d))/g, "")

  return `${formattedNumber}-${checkDigit}`
}
